// DeleteConfirmModal component - Confirmation dialog for deleting fuel records

import Modal from "./Modal";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, record }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="text-center py-4">
        {/* Warning Icon */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
          <svg
            className="h-10 w-10 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          ยืนยันการลบข้อมูล
        </h3>

        {/* Message */}
        <p className="text-gray-600 mb-6">
          คุณต้องการลบข้อมูลการเติมน้ำมันนี้หรือไม่?
        </p>

        {/* Record Details */}
        {record && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <span className="text-gray-500">วันที่:</span>
                <p className="font-semibold text-gray-900">
                  {record.date || "-"}
                </p>
              </div>
              <div>
                <span className="text-gray-500">ป้ายทะเบียน:</span>
                <p className="font-semibold text-gray-900">
                  {record.license_plate || "-"}
                </p>
              </div>
              <div>
                <span className="text-gray-500">ปั๊มน้ำมัน:</span>
                <p className="font-semibold text-gray-900">
                  {record.gas_station || "-"}
                </p>
              </div>
              <div>
                <span className="text-gray-500">เลขไมล์:</span>
                <p className="font-semibold text-indigo-600">
                  {Number(record.mileage || 0).toLocaleString()} km
                </p>
              </div>
              <div>
                <span className="text-gray-500">จำนวนเงิน:</span>
                <p className="font-semibold text-orange-600">
                  {Number(record.amount || 0).toLocaleString("th-TH", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{" "}
                  บาท
                </p>
              </div>
              <div>
                <span className="text-gray-500">ปริมาณ:</span>
                <p className="font-semibold text-blue-600">
                  {Number(record.oil_volume || 0).toLocaleString("th-TH", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{" "}
                  ลิตร
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Warning Message */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-6">
          <p className="text-sm text-red-800">
            ⚠️ การดำเนินการนี้ไม่สามารถย้อนกลับได้
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 justify-center">
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 font-medium transition-colors duration-200 min-w-[120px]"
          >
            ยกเลิก
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium transition-colors duration-200 min-w-[120px] shadow-lg shadow-red-500/30"
          >
            ลบข้อมูล
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
